import React from 'react';
import PropTypes from 'prop-types';

function HelpMenu({help}) {
    const renderItem = (item, index) => {
        return (
            <a className="site-header-tray__menu-item-link site-header-tray__menu-item-link--help" data-bypass="true" href={item.link} key={`link-${index}`} target="_blank">{item.text}</a>
        );
    };

    return (
        <div className="site-header-tray__menu site-header-tray__drawer">
            <div className="site-header-tray__items">
                {help.items.map(renderItem)}
            </div>
        </div>
    );
}

HelpMenu.propTypes = {
    help: PropTypes.shape({})
};

export {HelpMenu};